import React from "react";
import PropTypes from "prop-types";
import { useDenseViewContext } from "./DenseViewContext";
import { getMaintenanceClass } from "./utility_functions";
import { SHIFT_LOG_TASK_FIELDS } from "../../constants";

const ShiftLogContainerHospice = ({ shiftLog }) => {
  const { state } = useDenseViewContext();

  return (
    <>
      {state["Hygiene"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Hygiene</h3>
          </summary>
          <div className="log-rows">
            {SHIFT_LOG_TASK_FIELDS.map((shift_log_task) => {
              const key = shift_log_task.value;
              if (!state[key]) return <></>;
              return (
                <>
                  <span className={`log-rows__icon ${getMaintenanceClass(shiftLog[key])}`}></span>
                  <b>{shift_log_task.label}:</b>
                  <div className="log-rows__text">{shiftLog[shift_log_task.textKey]}</div>
                </>
              );
            })}
          </div>
        </details>
      )}

      {state["Additional Hygiene"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Additional Hygiene</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bedbath)}`}
            ></span>
            <b>Bedbath:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_partial_bedbath)}`}
            ></span>
            <b>Partial Bedbath:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_shower)}`}
            ></span>
            <b>Shower:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_shave)}`}
            ></span>
            <b>Shave:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_hair_wash)}`}
            ></span>
            <b>Hair Wash:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_peri_care)}`}
            ></span>
            <b>Peri-Care:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_mouth_care)}`}
            ></span>
            <b>Mouth-Care:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_repositioned)}`}
            ></span>
            <b>Repositioned:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_pa_checked)}`}
            ></span>
            <b>P.A. Checked:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_nail_care)}`}
            ></span>
            <b>Nail Care:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_other_hygiene)}`}
            ></span>
            <b>Other Hygiene:</b>
            <div className="log-rows__text">{shiftLog.hospice_other_hygiene_text}</div>
          </div>
        </details>
      )}

      {state["Mobility"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Mobility</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bed_bound)}`}
            ></span>
            <b>Bed Bound:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_assist_x1)}`}
            ></span>
            <b>Assist x1:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_assist_x2)}`}
            ></span>
            <b>Assist x2:</b>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_lift)}`}></span>
            <b>Lift:</b>
          </div>
        </details>
      )}

      {state["Cognition"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Cognition</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_alert)}`}
            ></span>
            <b>Alert:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_drowsy)}`}
            ></span>
            <b>Drowsy:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_somnolent)}`}
            ></span>
            <b>Somnolent:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_semi_coma)}`}
            ></span>
            <b>Semi-coma:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_confusion)}`}
            ></span>
            <b>Confusion:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_hallucination)}`}
            ></span>
            <b>Hallucination:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_agitation)}`}
            ></span>
            <b>Agitation:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_anxiety)}`}
            ></span>
            <b>Anxiety:</b>
          </div>
        </details>
      )}

      {state["Nutrition"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Nutrition</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_dat_good_poor)}`}
            ></span>
            <b>DAT, Good, Poor:</b>
            <div className="log-rows__text">{shiftLog.hospice_dat_good_poor_text}</div>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_soft)}`}></span>
            <b>Soft:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_fluids)}`}
            ></span>
            <b>Fluids:</b>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_sips)}`}></span>
            <b>Sips:</b>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_npo)}`}></span>
            <b>NPO:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_nausea_vomiting)}`}
            ></span>
            <b>Nausea/Vomiting:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_dysphagia)}`}
            ></span>
            <b>Dysphagia:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_enteral_feed)}`}
            ></span>
            <b>Enteral Feed:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_food_intake)}`}
            ></span>
            <b>Food intake:</b>
          </div>
        </details>
      )}

      {state["Elimination"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Elimination</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bladder_void)}`}
            ></span>
            <b>Bladder void:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_continent_urine)}`}
            ></span>
            <b>Continent Urine:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(
                shiftLog.hospice_foley_neph_amount
              )}`}
            ></span>
            <b>Foley/Neph amount:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bowel_void)}`}
            ></span>
            <b>Bowel void:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_continent_feces)}`}
            ></span>
            <b>Continent Feces:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bm_size)}`}
            ></span>
            <b>BM Small/Med/Large:</b>
            <div className="log-rows__text">{shiftLog.hospice_bm_size_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bm_type)}`}
            ></span>
            <b>BM Normal/Loose/Diarrhea/Constipated:</b>
            <div className="log-rows__text">{shiftLog.hospice_bm_type_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(
                shiftLog.hospice_urine_foley_amount
              )}`}
            ></span>
            <b>Urine Foley Amount:</b>
            <div className="log-rows__text">{shiftLog.hospice_urine_foley_amount_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_commode)}`}
            ></span>
            <b>Commode:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_urinal)}`}
            ></span>
            <b>Urinal:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_attends)}`}
            ></span>
            <b>Attends:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_colostomy)}`}
            ></span>
            <b>Colostomy:</b>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_ileo)}`}></span>
            <b>Ileo:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(
                shiftLog.hospice_colostomy_emptied
              )}`}
            ></span>
            <b>Colostomy emptied:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(
                shiftLog.hospice_colostomy_changed
              )}`}
            ></span>
            <b>Colostomy changed:</b>
          </div>
        </details>
      )}

      {state["Cardio/Resp"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Cardio/Resp</h3>
          </summary>
          <div className="log-rows">
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_oxygen)}`}
            ></span>
            <b>Oxygen:</b>

            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_rate)}`}></span>
            <b>Rate:</b>
            <div className="log-rows__text">{shiftLog.hospice_rate_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_o2_sat)}`}
            ></span>
            <b>O2 Sat:</b>
            <div className="log-rows__text">{shiftLog.hospice_o2_sat_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_dyspnea)}`}
            ></span>
            <b>Dyspnea:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_congestion)}`}
            ></span>
            <b>Congestion:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_cough)}`}
            ></span>
            <b>Cough:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_hemoptosis)}`}
            ></span>
            <b>Hemoptosis:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_pleurex)}`}
            ></span>
            <b>Pleurex:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_pulse)}`}
            ></span>
            <b>Pulse:</b>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_resp_rate)}`}
            ></span>
            <b>Resp Rate:</b>
            <div className="log-rows__text">{shiftLog.hospice_resp_rate_text}</div>

            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_apnea)}`}
            ></span>
            <b>Apnea:</b>
          </div>
        </details>
      )}

      {state["Skin"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>Skin</h3>
          </summary>
          <div className="log-rows">
            <span className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_rash)}`}></span>
            <b>Rash:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_puritis)}`}
            ></span>
            <b>Puritis:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bruising)}`}
            ></span>
            <b>Bruising:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_edema)}`}
            ></span>
            <b>Edema (A, L, Abd.):</b>
            <div className="log-rows__text">{shiftLog.hospice_edema_text}</div>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_wound)}`}
            ></span>
            <b>Wound, See tx. sh.:</b>
            <div className="log-rows__text">{shiftLog.hospice_wound_text}</div>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_mottling)}`}
            ></span>
            <b>Mottling:</b>
          </div>
        </details>
      )}

      {state["General"] && (
        <details open>
          <summary className="log-rows-category">
            <h3>General</h3>
          </summary>
          <div className="log-rows">
            {" "}
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_sleep)}`}
            ></span>{" "}
            <b>Sleep:</b>{" "}
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_teaching)}`}
            ></span>
            <b>Teaching:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(
                shiftLog.hospice_emotional_support
              )}`}
            ></span>
            <b>Emotional Support:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_bed_alarm)}`}
            ></span>
            <b>Bed Alarm:</b>
            <span
              className={`log-rows__icon ${getMaintenanceClass(shiftLog.hospice_other)}`}
            ></span>
            <b>Other:</b>
            <div className="log-rows__text">{shiftLog.hospice_other_text}</div>
          </div>
        </details>
      )}
    </>
  );
};

export default ShiftLogContainerHospice;
ShiftLogContainerHospice.propTypes = {
  shiftLog: PropTypes.object.isRequired
};
